import { Component, EventEmitter, Input, OnDestroy, Output, OnInit} from '@angular/core';
import { Subscription } from 'rxjs';
import { ErrorService } from 'src/app/services/error.service';
import { EventBrokerService } from 'src/app/services/event-broker.service';
import { SideBarService } from 'src/app/services/side-bar.service';
import { ListFilterService, FilterProperty, FilterMode, FilterPropertyChanged,StringDataBag, DateDataBag} from './list-filter-service';


@Component({
  selector: 'app-list-filter',
  templateUrl: './list-filter.component.html'
})
export class ListFilterComponent implements OnDestroy {
  @Input()
  isMultiplePropertyFilterVisible: boolean;

  @Input()
  isCloseButtonVisible = true;

  @Input()
  mode: 'List' | 'Search' = 'List';

  @Output()
  isMultiplePropertyFilterVisibleChange = new EventEmitter<boolean>();

  #items: any[];
  get items(): any[] {
    return this.#items;
  }

  @Input()
  set items(value: any[]) {
    if (!value || value.length <= 0 || value === this.#items) return;
    //if (value === this.#items) return;
    this.#items = value;
    this.createFilterService();
  }

  #properties: FilterProperty[]
  get properties(): FilterProperty[] {
    return this.#properties;
  }

  @Input()
  set properties(value: FilterProperty[]) {
    if (!value || value.length <= 0 || value === this.#properties) return;
   //if (value === this.#properties) return;
    this.#properties = value;
    this.multipleProperties = this.properties.filter(x => x.IsVisibleOnMultiplePropertyFilter);
    this.createFilterService();
  }

  @Output() filterChanged = new EventEmitter<any[]>();
  @Output() filterPropertyChanged = new EventEmitter<any[]>();

  filterService: ListFilterService;
  multipleProperties: FilterProperty[];

  currentPropertyFilter: FilterProperty;
  currentPropertyFilterMode: FilterMode;
  itemCount: number;

  #seeAllSubscription: Subscription;
  #filterByRequestedSubscription: Subscription;
  //#navigateToDetail: Subscription;

  filterRequestItem:any[]; 
  filteredRequestList:any[];
  fRequestList:any[];

  sessionObj:string = '';
  sessionPropertyObj:string = '';
  fPropertyList:any[];
  listFilterSessionObj={};

  restoredFilterItems:any=[];

  constructor(public sidebar: SideBarService, 
              private eventBroker: EventBrokerService, 
              private errorService:ErrorService) {
      this.#seeAllSubscription = eventBroker.subscribe('SeeAll', this.seeAllHandler);
      this.#filterByRequestedSubscription = eventBroker.subscribe('FilterByRequested', this.filterByRequestedHandler);
      
  }
  
  
  ngOnDestroy(): void {
    if (this.#seeAllSubscription) this.#seeAllSubscription.unsubscribe();
    if (this.#filterByRequestedSubscription) this.#filterByRequestedSubscription.unsubscribe();
    
    console.log('Filter component distroyed');
   // if(this.filterRequestItem && String(url).indexOf('detail') > -1){
     
    if(this.filterRequestItem){
      this.listFilterSessionObj['path'] = this.sessionObj;
      this.listFilterSessionObj['requestList'] = this.filterRequestItem;
      this.listFilterSessionObj['propertyList'] = this.properties;
      sessionStorage.setItem("ListFilterSessionObj", JSON.stringify(this.listFilterSessionObj));
    }else{
      sessionStorage.removeItem("ListFilterSessionObj");
    }
  }

  private filterByRequestedHandler = (property: FilterProperty) => {
    this.showPropertyFilter(property, 'FilterBy');
  }

  private seeAllHandler = (property: FilterProperty) => {
    this.showPropertyFilter(property, 'SeeAll');
  }

  private showPropertyFilter(property: FilterProperty, mode: FilterMode) {
    if (!this.#properties || this.#properties.indexOf(property) < 0) return;
    this.currentPropertyFilter = property;
    this.currentPropertyFilterMode = mode;
    this.sidebar.show('PropertyFilter');
  }

  private createFilterService() {
    if (this.#properties && this.#items) {
      this.itemCount = this.#items.length;
      if (this.itemCount > 0) {
        this.filterService = new ListFilterService(this.#properties, this.#items, this.eventBroker,this.errorService);
        this.updateProperties();
        this.emitFilterChanged();
      }

    }
  }

  updateProperties(){
      let url = window.location;
      if(url.search){
        this.sessionObj = url.pathname.replace('/','')+'-'+url?.search.split("=")[1];
      }else{
        this.sessionObj = url.pathname.replace('/','');
      }
      const listfilterSeesionObj = JSON.parse(sessionStorage.getItem('ListFilterSessionObj'));
      
      if(listfilterSeesionObj){
        if(listfilterSeesionObj.path == this.sessionObj){
          if(listfilterSeesionObj.propertyList){
           const prop = listfilterSeesionObj.propertyList;
           this.properties.forEach(element => {
              prop.forEach(e => {
                if(element.DisplayName == e.DisplayName && e.Description){
                  if(e.Type == "Date"){
                    const dateDataBag = element.DataBag as DateDataBag;
                    dateDataBag.Mode = e.DataBag?.Mode;
                    dateDataBag.SelectedOptions = e.DataBag?.SelectedOptions;
                    if(dateDataBag.SelectedOptions && dateDataBag.SelectedOptions?.length > 0){
                      e.DataBag?.SelectedOptions?.forEach((dt,index) => {
                        dateDataBag.SelectedOptions[index].Value = new Date(dt?.Value);
                      });
                    }
                    dateDataBag.SelectedOptionsHistory = e.DataBag?.SelectedOptionsHistory;
                    element.Description = e?.Description;
                    element.IsFiltered = e.IsFiltered;
                  }else{
                    const bag = element.DataBag as StringDataBag;
                    bag.SelectedOptions = e.DataBag?.SelectedOptions;
                    bag.SelectedOptionsHistory = e.DataBag?.SelectedOptionsHistory;
                    element.Description = e?.Description;
                    element.IsFiltered = e.IsFiltered;
                  }
                  
                }
             })
           })
          }
          console.log('properties',this.properties);
          sessionStorage.removeItem("ListFilterSessionObj");
        }else{
          
          sessionStorage.removeItem("ListFilterSessionObj");
        }
     }
  }

  emitFilterChanged(): void {
    if (!this.items || this.items.length === 0) {
      this.filterChanged.emit([]);
      return;
    }
      let filteredItems:any[];
      filteredItems = this.filterService.getFiltedItems();
      this.filterRequestItem = filteredItems;
      this.itemCount = filteredItems.length;
  //  if (this.itemCount > 0 && !(this.items.length === this.itemCount)) {
      this.filterChanged.emit(filteredItems);
  /*  } else {
      if (this.itemCount > 0) {
        this.filterChanged.emit(this.items);
      }
    }*/
    
  }

  filterBy(filterProperty: FilterProperty): void {
    this.currentPropertyFilterMode = 'FilterBy';
    this.currentPropertyFilter = filterProperty;
    this.sidebar.show('PropertyFilter');
  }

  closeMultiplePropertyFilter() {
    this.isMultiplePropertyFilterVisible = false;
    this.isMultiplePropertyFilterVisibleChange.emit(false);
  }
  
}
